import { render, staticRenderFns } from "./ProjectSummaryFollow.vue?vue&type=template&id=b1509544"
import script from "./ProjectSummaryFollow.vue?vue&type=script&lang=js"
export * from "./ProjectSummaryFollow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports